// ---------- Config ----------
const PARTNER_PARAM_PREFIX = '_partner_';

// ---------- Helpers ----------
function isPartnerKey( key ) {
  return key.startsWith( PARTNER_PARAM_PREFIX );
}
function hasPartnerParams( params ) {
  for ( const key of params.keys() ) if ( isPartnerKey( key ) ) return true;
  return false;
}
function buildUrlWithOnlyPartnerParams( sourceUrl ) {
  const src = new URL( sourceUrl, window.location.origin );
  const next = new URL( window.location.href );
  next.search = ''; // clear all params
  src.searchParams.forEach( ( v, k ) => {
    if ( isPartnerKey( k ) ) next.searchParams.set( k, v );
  } );
  return next;
}
function pushUrl( url ) {
  // Use pushState (or replaceState if you prefer not growing history)
  window.history.pushState( {}, '', url );
}
function firePopstateOnce() {
  // Some browsers require try/catch for synthetic PopStateEvent
  try {
    window.dispatchEvent( new PopStateEvent( 'popstate', { state: {} } ) );
  } catch {
    const evt = document.createEvent( 'PopStateEvent' );
    evt.initPopStateEvent( 'popstate', true, true, {} );
    window.dispatchEvent( evt );
  }
}
function smoothScrollTo( el ) {
  el.scrollIntoView( { behavior: 'smooth', block: 'start' } );
}
function waitForSectionThenScroll( sectionEl, timeoutMs = 1500 ) {
  // If content already present, scroll shortly
  if ( sectionEl.children.length > 0 ) {
    setTimeout( () => smoothScrollTo( sectionEl ), 100 );
    return;
  }
  let done = false;
  const finish = ( obs ) => {
    if ( done ) return;
    done = true;
    if ( obs ) obs.disconnect();
    smoothScrollTo( sectionEl );
  };
  const obs = new MutationObserver( () => {
    if ( sectionEl.children.length > 0 ) finish( obs );
  } );
  obs.observe( sectionEl, { childList: true } );
  setTimeout( () => finish( obs ), timeoutMs );
}

// ---------- Click handling (single final URL update, single popstate) ----------
function handlePartnerLinkClick( e, linkEl, sectionEl, lock ) {
  const href = linkEl.getAttribute( 'href' );
  if ( !href || lock.value ) return;

  const targetUrl = new URL( href, window.location.origin );
  if ( targetUrl.pathname !== window.location.pathname ) return; // different page → allow navigation

  e.preventDefault();
  lock.value = true; // prevent double clicks while filtering is in-flight

  // Build final URL containing only the clicked partner params
  const nextUrl = buildUrlWithOnlyPartnerParams( targetUrl );

  // Set final URL once, then notify listeners once
  pushUrl( nextUrl );

  // Defer the event by a task tick to ensure history state is settled
  setTimeout( () => {
    firePopstateOnce();
    waitForSectionThenScroll( sectionEl );
    // Unlock after scroll starts; if your filtering is slow, you can delay unlock more
    setTimeout( () => { lock.value = false; }, 200 );
  }, 0 );
}

// ---------- Initial load behavior ----------
function handleInitialLoad( sectionEl ) {
  const params = new URLSearchParams( window.location.search );
  if ( !hasPartnerParams( params ) ) return;
  waitForSectionThenScroll( sectionEl );
}

// ---------- Bind partner links ----------
function bindPartnerLinks( sectionEl ) {
  const links = document.querySelectorAll( 'a[href*="_partner_"]' );
  if ( !links.length ) return;

  // simple lock to avoid multiple concurrent clicks
  const lock = { value: false };

  links.forEach( ( link ) => {
    link.addEventListener( 'click', ( e ) => handlePartnerLinkClick( e, link, sectionEl, lock ) );
  } );
}

// ---------- Public init ----------
function initPartnersDeepLinkScroll( sectionSelector = '#imp_partners' ) {
  const sectionEl = document.querySelector( sectionSelector );
  if ( !sectionEl ) return;
  handleInitialLoad( sectionEl );
  bindPartnerLinks( sectionEl );
}

document.addEventListener( 'DOMContentLoaded', () => {
  initPartnersDeepLinkScroll( '#imp_partners' );
} );
